
<div class="grid-container padding-y-4">
  <div class="grid-row grid-gap">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2"></div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
      <form [formGroup]="newOktaUserForm">
        <div class="grid-row grid-gap">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--large">Create Password</legend>
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            @if (isContainApps) {
              <div  class="usa-alert usa-alert--success usa-alert--no-icon">
                <div class="usa-alert__body">
                  <p class="usa-alert__text">
                    &nbsp; {{ containAppsMessage }}
                  </p>
                </div>
              </div>
            }
            @if (isUserAlreadyExists) {
              <div   class="usa-alert usa-alert--error usa-alert--no-icon">
                <div class="usa-alert__body">
                  <p class="usa-alert__text">
                    &nbsp; {{ userAlreadyExistsMessage }}
                  </p>
                </div>
              </div>
            }
            @if (registrationSuccessful) {
              <div  class="usa-alert usa-alert--success usa-alert--no-icon">
                <div class="usa-alert__body">
                  <div [innerHTML]="message"></div>
                </div>
              </div>
            }
            @if (registrationFailed) {
              <div  class="usa-alert usa-alert--error usa-alert--no-icon">
                <div class="usa-alert__body">
                  <p class="usa-alert__text">
                    &nbsp; {{this.message}}
                  </p>
                </div>
              </div>
            }
          </div>
          @if (!registrationSuccessful) {
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <div class="grid-row grid-gap">
                <div  class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                  <label class="usa-label" for="firstName">First Name</label>
                  <input type="text" id="firstName" class="usa-input maxw-full" readonly formControlName="firstName">
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                  <label class="usa-label" for="lastName">Last Name</label>
                  <input type="text" id="lastName" class="usa-input maxw-full" readonly formControlName="lastName">
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                  <div class="form-group col-xs-12">
                    <label class="usa-label" for="email">Email</label>
                    <input type="text" id="email" class="usa-input maxw-full" readonly formControlName="email">
                  </div>
                </div>
                @if (isUserAlreadyExists == false) {
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <div class="grid-row grid-gap">
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                        <label class="usa-label" for="newPassword">New Password</label>
											<input type="password" id="newPassword" class="usa-input maxw-full" formControlName="newPassword" [ngClass]="{
											'border-success': this.newOktaUserForm.get('newPassword').valid && this.newOktaUserForm.get('newPassword').touched,
											'border-danger': this.newOktaUserForm.get('newPassword').invalid && this.newOktaUserForm.get('newPassword').touched}">
                        @if (this.newOktaUserForm.get('newPassword').invalid && (this.newOktaUserForm.get('newPassword').touched || this.newOktaUserForm.get('newPassword').dirty)) {
                          <div class="define-text-secondary" >
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>New Password is required
                          </div>
                        }
                      </div>
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 help-text text-muted">
                        Password must be at least 12 characters,
                        a lowercase letter, an uppercase letter, a number, a symbol, no parts of your username,
                        does not include your first name, does not include your last name.
                        Your password cannot be any of your last 24 passwords.
                      </div>
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                        <label class="usa-label" for="confirmPassword">Confirm Password</label>
										<input type="password" id="confirmPassword" class="usa-input w-100" formControlName="confirmPassword" [ngClass]="{
										'border-success': this.newOktaUserForm.get('confirmPassword').valid && this.newOktaUserForm.get('confirmPassword').touched,
										'border-danger': this.newOktaUserForm.get('confirmPassword').invalid && this.newOktaUserForm.get('confirmPassword').touched}">
                        @if (this.newOktaUserForm.get('confirmPassword').invalid && (this.newOktaUserForm.get('confirmPassword').touched || this.newOktaUserForm.get('confirmPassword').dirty)) {
                          <div class="define-text-secondary">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg> Confirm Password is required
                          </div>
                        }
                        @if ((this.newOktaUserForm.get('newPassword').value !== '') && (this.newOktaUserForm.get('confirmPassword').hasError('same'))) {
                          <div class="define-text-secondary">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>  Password mismatch
                          </div>
                        }
                      </div>
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12"></div>
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                        <label class="usa-label" for="security_question">Security Question</label>
                        <select id="security_question" formControlName="securityQuestion" class="usa-select maxw-full" (change)="changeQuestion();">
                          <option value ='null' selected disabled>Choose...</option>
                          <option value ='What is the food you least liked as a child?'>What is the food you least liked as a child?</option>
                          <option value ='What is the name of your first stuffed animal?'>What is the name of your first stuffed animal?</option>
                          <option value ='What did you earn your first meadal or award for?'>What did you earn your first medal or award for?</option>
                          <option value ='What is your favorite security question?'>What is your favorite security question?</option>
                          <option value ='What is the toy/stuffed animal you liked the most as a kid?'>What is the toy/stuffed animal you liked the most as a kid?</option>
                          <option value ='What was the first computer game you played?'>What was the first computer game you played?</option>
                          <option value ='What is your favorite movie quote?'>What is your favorite movie quote?</option>
                          <option value ='What was the mascot of the first sports team you played on?'>What was the mascot of the first sports team you played on?</option>
                          <option value ='What music album or song did you first purchase?'>What music album or song did you first purchase?</option>
                          <option value ='What is your favorite piece of art?'>What is your favorite piece of art?</option>
                        </select>
                      </div>
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                        <label class="usa-label" for="securityAnswer">Your Answer</label>
										<input type="text" id="securityAnswer" class="usa-input maxw-full" formControlName="securityAnswer" [ngClass]="{
										'border-success': this.newOktaUserForm.get('securityAnswer').valid && this.newOktaUserForm.get('securityAnswer').touched,
										'border-danger': this.newOktaUserForm.get('securityAnswer').invalid && this.newOktaUserForm.get('securityAnswer').touched}">
                        @if (this.newOktaUserForm.get('securityAnswer').invalid && (this.newOktaUserForm.get('securityAnswer').touched || this.newOktaUserForm.get('securityAnswer').dirty)) {
                          <div class="define-text-secondary">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                            </svg>Your Answer is required
                            @if (newOktaUserForm.get('securityAnswer').hasError('minlength')) {
                              <div>
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                </svg> Your Answer must be 4 characters
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
        @if (passwordError) {
          <div class="grid-row mt-4">
            <div class="usa-alert usa-alert--error usa-alert--slim">
              <div class="usa-alert__body">
                <p class="usa-alert__text">
                  &nbsp; {{passwordError}}
                </p>
              </div>
            </div>
          </div>
        }
        <div class="grid-row mt-4">
          @if (!registrationSuccessful) {
            <button type="button" class="usa-button" [disabled]="newOktaUserForm.invalid || this.disabled || registrationSuccessful" (click)='saveOktaUser(this.newOktaUserForm.value)'>Create Password</button>
          }
        </div>
      </form>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2"></div>
  </div>
</div>
